import React from 'react';
import ProdutoService from '../services/ProdutoService';
import { Rating } from 'primereact/rating';
import { Button } from 'primereact/button';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { hideProcess, showProcess } from '../utils/utils';
import CarrinhoService from '../services/CarrinhoService';
import iconTrash from '../img/trash.svg'
import iconMinus from '../img/minus.svg'
import iconPlus from '../img/plus.svg'
import iconClapping from '../img/icon-clapping-hand.svg'
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import PedidoService from '../services/PedidoService';


class Carrinho extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            
            
        }
    }

    async componentDidMount(){    
        try{
        
            await showProcess();

            const response = await CarrinhoService.create();
            
            localStorage.setItem("carrinho", response.data.object);

            this.setState({carrinho: response.data.object});
            

        }catch(e){
            alert(e)
        }
        
        hideProcess();
        
    }

    setQuantidade = async (quantidade, index) => {

        if (quantidade > 0){

            var carrinho = this.state.carrinho;

            carrinho.itens[index].quantidade = quantidade;

            await this.setState({carrinho: carrinho, salvarCarrinho: true});

        }
        
    }

    save = async () => {
        try{
        
            await showProcess();

            const response = await CarrinhoService.save(this.state.carrinho);
            
            localStorage.setItem("carrinho", response.data.object);

            this.setState({carrinho: response.data.object, salvarCarrinho: false});
            

        }catch(e){
            alert(e)
        }
        
        hideProcess();
    }

    onBlurQuantidade = async () => {

        if (this.state.salvarCarrinho){
            await this.save();
        }
        
    }

    removerItem = async (item, index) => {
        try{
        
            await showProcess();

            const response = await CarrinhoService.removeItem(item);

            if (response.data.status === "sucess"){

                var carrinho = this.state.carrinho;

                carrinho.itens.splice(index, 1);

                localStorage.setItem("carrinho", carrinho);

                this.setState({carrinho: carrinho});

            }else{
                alert(response.data.message);
            }   
            

        }catch(e){
            alert(e)
        }
        
        hideProcess();
    }

    gerarPedido = async () => {

        if (!window.confirm("Confirma a geração do Pedido?")){
            return
        }

        try{
        
            await showProcess();

            const response = await PedidoService.create(this.state.carrinho);

            if (response.data.status === "sucess"){
                this.setState({pedido: response.data.object});
            }else{
                alert(response.data.message);
            }               

        }catch(e){
            alert(e)
        }
        
        hideProcess();

    }

    render() {
        return(
            <>
                <div style={{height: 'calc(100% - 60px)', overflow: 'auto', padding: '0px 10px'}}>
                    {this.state.carrinho !== undefined &&
                        this.state.carrinho.itens.map((item, index) => 
                            <table style={{width: '100%'}} className='app-item-cart'>
                                <tr>
                                    <td rowSpan={2} style={{width: '100px'}}><img src={item.produto.imagem !== null ? item.produto.imagem : require('../img/no-image.jpeg')} style={{height: '100px', objectFit: 'contain', backgroundColor: '#ffffff'}}/></td>
                                    <td style={{textAlign: 'left'}}>{item.produto.nome}</td>
                                    <td rowSpan={2} style={{width: '40px', textAlign: 'center'}}><img src={iconTrash} style={{width: '24px', cursor: 'pointer'}} onClick={() => this.removerItem(item, index)}/></td>
                                </tr>
                                <tr>
                                    <td>
                                        <table>
                                            <tr>
                                                <td>
                                                    <img src={iconMinus} style={{width: '24px', cursor: 'pointer'}} onClick={async () => {if (item.quantidade > 1) {await this.setQuantidade(item.quantidade - 1, index); await this.save()}}}/>
                                                </td>
                                                <td>
                                                    <InputNumber value={item.quantidade} min={1} onChange={(e) => this.setQuantidade(e.value, index)} inputStyle={{width: '100%', textAlign: 'center', width: '50px'}} minFractionDigits={0} maxFractionDigits={0} onBlur={() => this.onBlurQuantidade()}/>
                                                </td>
                                                <td>
                                                    <img src={iconPlus} style={{width: '24px', cursor: 'pointer'}} onClick={async () => {await this.setQuantidade(item.quantidade + 1, index); await this.save()}}/>
                                                </td>
                                            </tr>

                                        </table>
                                    </td>
                                </tr>
                                
                                
                            </table>    
                        )
                    }
                </div>
                <div style={{height: '60px', padding: '10px 0px'}}>
                    {this.state.carrinho !== undefined &&
                        <Button label='CONFIRMAR PEDIDO'  className='app-background-gold' disabled={this.state.carrinho.itens.length === 0} style={{padding: '10px', border: '2px solid #DAA520', margin: '0 auto', width: '100%', height: '40px'}} onClick={() => this.gerarPedido()}/>
                    }
                </div>
                {this.state.pedido !== undefined &&
                    <Dialog visible={true} closable={false}>
                        <table>
                            <tr>
                                <td style={{width: '50px'}}>
                                    <img src={iconClapping} style={{width: '40px'}}/>
                                </td>
                                <td>
                                    <h1 className='app-font-30'>Pedido Finalizado!</h1>
                                </td>
                            </tr>
                        </table>
                        <p>Obrigado pela sua preferência. Seu pedido foi realizado com sucesso e em breve será processado.</p>

                        <Button label='ACOMPANHAR O PEDIDO'  className='app-background-gold' style={{padding: '10px', border: '2px solid #DAA520', margin: '0 auto', width: '100%', height: '40px', marginBottom: '10px'}} onClick={() => window.location.href = "/pedido/"+this.state.pedido.id}/>
                        <Button label='VOLTAR A LOJA'  className='app-background-gold' style={{padding: '10px', border: '2px solid #DAA520', margin: '0 auto', width: '100%', height: '40px'}} onClick={() => window.location.href = "/loja"}/>
                        
                    </Dialog>
                }
                
            </>
        );
        
    }


}
export default Carrinho;
